import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from 'app/client-core/services/user.service';

@Pipe({
  name: 'siteConfigurationValue'
})
export class SiteConfigurationValuePipe implements PipeTransform {
  constructor(
    private userService: UserService
  ) {

  }
  transform(value: any, args?: any): any {
    const config = this.userService.getClientSettingsFromLocalStorage(value);
    if (config) {
      return config.operation;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/site-configuration-value.pipe.ts